module.exports = __webpack_public_path__ + "img/gaugeBg.0ca36f85.png";